<!-- Affichage conditionnel de l'alerte -->
<div class="alert alert-dismissible alert-danger d-flex">
  <span class="material-icons">report_problem</span>
  <button type="button" class="btn-close mt-2" (click)="dismissAlert()"></button>
  <div>
    {{ authenticationService.alertMessage }}
  </div>
</div>
